import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function OnboardError() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const clientId = params.get("clientId");

  return (
    <div style={s.wrap}>
      <style>{`@keyframes shake { 0%,100%{transform:translateX(0)} 20%,60%{transform:translateX(-8px)} 40%,80%{transform:translateX(8px)} }`}</style>
      <div style={s.icon}>❌</div>
      <div style={s.title}>Connection Failed</div>
      <div style={s.sub}>WhatsApp Business account connect nahi ho paya. Please dobara try karo.</div>
      <div style={s.actions}>
        <button onClick={handleWhatsAppConnect} style={s.retryBtn}>
          🔄 Dobara Try Karo
        </button>
        <button onClick={() => navigate(`/app/edit-client/${clientId}`)} style={s.backBtn}>
          ← Wapas Jao
        </button>
      </div>
    </div>
  );

  async function handleWhatsAppConnect() {
    try {
      const API = (await import("../api")).default;
      const res = await API.get(`/auth/onboard-url/${clientId}`);
      window.location.href = res.data.onboardUrl;
    } catch {
      navigate(`/app/edit-client/${clientId}`);
    }
  }
}

const s = {
  wrap: {
    display: "flex", flexDirection: "column", alignItems: "center",
    justifyContent: "center", minHeight: "100vh", gap: 12,
    background: "var(--bg-base, #0f1117)", padding: 24, textAlign: "center",
  },
  icon: { fontSize: 56, animation: "shake 0.5s ease" },
  title: { fontSize: 22, fontWeight: 700, color: "var(--text-primary, #fff)", marginTop: 8 },
  sub: { fontSize: 14, color: "var(--text-muted, #888)", maxWidth: 320, lineHeight: 1.6 },
  actions: { display: "flex", gap: 12, marginTop: 20, flexWrap: "wrap", justifyContent: "center" },
  retryBtn: {
    padding: "10px 24px", borderRadius: "var(--radius, 8px)",
    background: "var(--accent, #4d9fff)", color: "#fff",
    border: "none", cursor: "pointer", fontSize: 14, fontWeight: 600,
  },
  backBtn: {
    padding: "10px 24px", borderRadius: "var(--radius, 8px)",
    background: "transparent", color: "var(--text-muted, #888)",
    border: "1px solid var(--border, #333)", cursor: "pointer", fontSize: 14,
  },
};
